export interface NumericAxisRange {
  min: number
  max: number
}

interface ExpandAxisRangeUpdatesArgs {
  rangeUpdates: Record<string, NumericAxisRange>
  singleScaleMode: boolean
  allAxisIds: string[]
}

export const translateAxisRange = (
  currentRange: NumericAxisRange,
  delta: number
): NumericAxisRange => {
  return {
    min: currentRange.min + delta,
    max: currentRange.max + delta,
  }
}

export const expandAxisRangeUpdates = ({
  rangeUpdates,
  singleScaleMode,
  allAxisIds,
}: ExpandAxisRangeUpdatesArgs): Record<
  string,
  { min?: number; max?: number }
> => {
  if (!singleScaleMode) {
    return Object.fromEntries(
      Object.entries(rangeUpdates).map(([axisId, range]) => [
        axisId,
        { min: range.min, max: range.max },
      ])
    )
  }

  const singleScaleRange = rangeUpdates['single-scale']
  if (!singleScaleRange) {
    return {}
  }

  const expandedRanges: Record<string, { min?: number; max?: number }> = {
    'single-scale': {
      min: singleScaleRange.min,
      max: singleScaleRange.max,
    },
  }

  allAxisIds.forEach((axisId) => {
    expandedRanges[axisId] = {
      min: singleScaleRange.min,
      max: singleScaleRange.max,
    }
  })

  return expandedRanges
}
